/**
 * The backend's HTTPException `detail` strings are all hardcoded in French (whole app was
 * originally French-only). Rather than touch ~50 call sites across the backend (real
 * regression risk on a system that's fully tested/working), this is a purely additive,
 * frontend-only translation lookup applied wherever a raw backend error is shown to the user
 * (Itération 51, 12/08/2026 - now that English is the new default UI language). French stays
 * completely untouched (pass-through) - only English gets translated. Any message not in this
 * dictionary silently falls back to the original French text (safe, no crash, matches the
 * exact behavior that existed before this file was introduced).
 */
const FR_TO_EN = {
  "Accès administrateur requis": "Administrator access required",
  "Accès non autorisé": "Unauthorized access",
  "Achat Google Play non valide, aucun jeton crédité": "Invalid Google Play purchase, no tokens credited",
  "Ambiance invalide": "Invalid mood",
  "Aperçu introuvable": "Preview not found",
  "Audio introuvable": "Audio not found",
  "Ce code promo a atteint sa limite d'utilisation": "This promo code has reached its usage limit",
  "Ce code promo a expiré": "This promo code has expired",
  "Ce compte a été bloqué": "This account has been blocked",
  "Ce lien de réinitialisation est invalide ou a expiré": "This reset link is invalid or has expired",
  "Cet achat a déjà été traité": "This purchase has already been processed",
  "Cet essai a déjà été récupéré par un autre compte": "This trial has already been claimed by another account",
  "Cette commande a déjà été payée": "This order has already been paid",
  "Cette génération n'est pas encore terminée": "This generation isn't finished yet",
  "Chanson introuvable": "Song not found",
  "Code promo invalide ou expiré": "Invalid or expired promo code",
  "Commande introuvable ou déjà payée": "Order not found or already paid",
  "Commande introuvable": "Order not found",
  "Commande non terminée": "Order not completed",
  "Confirmation requise": "Confirmation required",
  "Description trop longue (300 caractères maximum)": "Description too long (300 characters max)",
  "Durée invalide": "Invalid duration",
  "Décrivez un peu plus votre chanson (3 caractères minimum)": "Please describe your song a bit more (3 characters minimum)",
  "Email ou mot de passe incorrect": "Incorrect email or password",
  "Génération introuvable": "Generation not found",
  "Impossible de créer le paiement Mollie pour le moment": "Unable to create the payment right now",
  "Le message vocal est trop long (400 caractères maximum)": "The voice message is too long (400 characters max)",
  "Le mot de passe doit contenir au moins 6 caractères": "Password must be at least 6 characters",
  "Le mot de passe ne peut pas être modifié pour un compte Google": "Password can't be changed for a Google account",
  "Le nouveau mot de passe doit contenir au moins 6 caractères": "The new password must be at least 6 characters",
  "Lien de vérification invalide ou déjà utilisé": "Invalid or already used verification link",
  "Mollie non configuré": "Payments aren't configured yet",
  "Mot de passe actuel incorrect": "Current password is incorrect",
  "Mot de passe incorrect": "Incorrect password",
  "Nombre de versions invalide": "Invalid number of versions",
  "Non authentifié": "Not authenticated",
  "Pack de jetons invalide": "Invalid token pack",
  "Paiement Google Play introuvable": "Google Play payment not found",
  "Paiement introuvable": "Payment not found",
  "Pochette introuvable": "Cover art not found",
  "Position du message vocal invalide": "Invalid voice message position",
  "Session Google invalide": "Invalid Google session",
  "Session invalide ou expirée": "Invalid or expired session",
  "Session invalide": "Invalid session",
  "Seules les commandes en échec peuvent être relancées": "Only failed orders can be retried",
  "Solde de jetons insuffisant": "Insufficient token balance",
  "Style musical invalide": "Invalid musical style",
  "Un compte existe déjà avec cet email": "An account already exists with this email",
  "Un compte existe déjà avec cet email. Merci de vous connecter.": "An account already exists with this email. Please log in instead.",
  "Une génération est déjà en cours pour cette session": "A generation is already in progress for this session",
  "Utilisateur introuvable": "User not found",
  "Version invalide": "Invalid version",
  "Veuillez d'abord enregistrer votre voix dans votre profil (section Profil vocal) avant d'activer cette option": "Please record your voice in your profile (Voice profile section) before enabling this option",
  "Veuillez fournir l'email du destinataire du cadeau": "Please provide the gift recipient's email",
  "Veuillez fournir un titre personnalisé": "Please provide a custom title",
  "Veuillez fournir vos paroles personnalisées": "Please provide your custom lyrics",
  "Veuillez indiquer le message à dire dans votre message vocal personnalisé": "Please enter the message for your personalized voice message",
  "Veuillez téléverser votre photo personnalisée": "Please upload your custom photo",
  "Vous avez déjà généré un essai gratuit dans les dernières 24h. Créez un compte pour créer votre chanson complète !": "You've already generated a free trial in the last 24h. Create an account to make your full song!",
  "Fichier audio trop volumineux (20 Mo maximum)": "Audio file too large (20 MB max)",
  "Format audio non supporté (MP3, WAV, M4A ou WEBM uniquement)": "Unsupported audio format (MP3, WAV, M4A or WEBM only)",
  "Impossible de lire ce fichier audio, veuillez réessayer avec un autre fichier": "Couldn't read this audio file, please try another one",
  "Votre enregistrement est trop long (5 minutes maximum)": "Your recording is too long (5 minutes max)",
};

export function translateApiError(detail, language) {
  if (!detail || language === "fr") return detail;
  return FR_TO_EN[detail] || detail;
}
